import { useMemo, type PropsWithChildren } from 'react';

import {
  NotificationSettingsContext,
  type NotificationSettingsContextType,
} from '../contexts/NotificationSettingsContext.js';
import { useResourceNotificationClient } from '../hooks/useResourceNotificationClient.js';
import type {
  NotificationSettingsConfig,
  NotificationSettingsResourceNotification,
} from '../NotificationSettings.js';

/** @internal */
export function ResourceNotificationClient(
  props: PropsWithChildren<
    Pick<NotificationSettingsResourceNotification, 'config'>
  >,
) {
  const {
    toggleNotifications,
    loading,
    hasNotFoundError,
    hasReadPermission,
    hasWritePermission,
    enabled,
  } = useResourceNotificationClient(props.config);

  const contextValue = useMemo<NotificationSettingsContextType>(
    () => ({
      enabled,
      hasNotFoundError,
      hasReadPermission,
      hasWritePermission,
      loading,
      toggleNotifications,
    }),
    [
      enabled,
      hasNotFoundError,
      hasReadPermission,
      hasWritePermission,
      loading,
      toggleNotifications,
    ],
  );

  return (
    <NotificationSettingsContext.Provider value={contextValue}>
      {props.children}
    </NotificationSettingsContext.Provider>
  );
}

/**
 * @internal
 */
export function isResourceNotificationConfig(
  type: NotificationSettingsConfig['type'],
  config: NotificationSettingsConfig['config'],
): config is NotificationSettingsResourceNotification['config'] {
  return type === 'resource';
}
